/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  AcceptInvitationIn,
  AcceptWithNewAccountIn,
  AcceptedInvitationOut,
  HTTPValidationError
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type acceptInvitationResponse200 = {
  data: AcceptedInvitationOut
  status: 200
}

export type acceptInvitationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type acceptInvitationResponseSuccess = (acceptInvitationResponse200) & {
  headers: Headers;
};
export type acceptInvitationResponseError = (acceptInvitationResponse422) & {
  headers: Headers;
};

export type acceptInvitationResponse = (acceptInvitationResponseSuccess | acceptInvitationResponseError)

export const getAcceptInvitationUrl = () => {




  return `/api/invitations/accept`
}

/**
 * @summary Accept Invitation
 */
export const acceptInvitation = async (acceptInvitationIn: AcceptInvitationIn, options?: Parameters<typeof apiFetch>[1]): Promise<acceptInvitationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<acceptInvitationResponse>(getAcceptInvitationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(acceptInvitationIn)
  }
);}





export const getAcceptInvitationMutationKey = () => ['acceptInvitation'] as const;

export const getAcceptInvitationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvitation>>, TError,AcceptInvitationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptInvitation>>, TError,AcceptInvitationMutationVariables, TContext> => {

const mutationKey = getAcceptInvitationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptInvitation>>, AcceptInvitationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  acceptInvitation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof acceptInvitation>>>
    export type AcceptInvitationMutationBody = AcceptInvitationIn
    export type AcceptInvitationMutationError = HTTPValidationError
    export type AcceptInvitationMutationVariables = {data: AcceptInvitationIn}

    /**
 * @summary Accept Invitation
 */
export const useAcceptInvitation = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvitation>>, TError,AcceptInvitationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptInvitation>>,
        TError,
        AcceptInvitationMutationVariables,
        TContext
      > => {
      return useMutation(getAcceptInvitationMutationOptions(options), queryClient);
    }
    export type acceptInvitationWithNewAccountResponse200 = {
  data: AcceptedInvitationOut
  status: 200
}

export type acceptInvitationWithNewAccountResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type acceptInvitationWithNewAccountResponseSuccess = (acceptInvitationWithNewAccountResponse200) & {
  headers: Headers;
};
export type acceptInvitationWithNewAccountResponseError = (acceptInvitationWithNewAccountResponse422) & {
  headers: Headers;
};

export type acceptInvitationWithNewAccountResponse = (acceptInvitationWithNewAccountResponseSuccess | acceptInvitationWithNewAccountResponseError)

export const getAcceptInvitationWithNewAccountUrl = () => {




  return `/api/invitations/accept-new`
}

/**
 * @summary Accept Invitation With New Account
 */
export const acceptInvitationWithNewAccount = async (acceptWithNewAccountIn: AcceptWithNewAccountIn, options?: Parameters<typeof apiFetch>[1]): Promise<acceptInvitationWithNewAccountResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<acceptInvitationWithNewAccountResponse>(getAcceptInvitationWithNewAccountUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(acceptWithNewAccountIn)
  }
);}





export const getAcceptInvitationWithNewAccountMutationKey = () => ['acceptInvitationWithNewAccount'] as const;

export const getAcceptInvitationWithNewAccountMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvitationWithNewAccount>>, TError,AcceptInvitationWithNewAccountMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptInvitationWithNewAccount>>, TError,AcceptInvitationWithNewAccountMutationVariables, TContext> => {

const mutationKey = getAcceptInvitationWithNewAccountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptInvitationWithNewAccount>>, AcceptInvitationWithNewAccountMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  acceptInvitationWithNewAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptInvitationWithNewAccountMutationResult = NonNullable<Awaited<ReturnType<typeof acceptInvitationWithNewAccount>>>
    export type AcceptInvitationWithNewAccountMutationBody = AcceptWithNewAccountIn
    export type AcceptInvitationWithNewAccountMutationError = HTTPValidationError
    export type AcceptInvitationWithNewAccountMutationVariables = {data: AcceptWithNewAccountIn}

    /**
 * @summary Accept Invitation With New Account
 */
export const useAcceptInvitationWithNewAccount = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvitationWithNewAccount>>, TError,AcceptInvitationWithNewAccountMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptInvitationWithNewAccount>>,
        TError,
        AcceptInvitationWithNewAccountMutationVariables,
        TContext
      > => {
      return useMutation(getAcceptInvitationWithNewAccountMutationOptions(options), queryClient);
    }
